@if (isLoading | async) {
  <div id="loader">
    <div id="spinner"></div>
  </div>
}
